import { FunctionComponent } from "react";
import { Outlet } from "react-router-dom";
import { Footer } from "@App/Layouts/Footer";

export const Layout: FunctionComponent = () => {
  return (
    <div className="text-neutral-900">
      <Outlet />
      <Footer />
    </div>
  );
};
